import { Role, RoleInfo } from "../Enums/Role";
import { type UserRoles } from "./type";

const ADMIN = RoleInfo[Role.ADMIN].name;
const MANAGER = RoleInfo[Role.MANAGER].name;
const SUPERVISOR = RoleInfo[Role.SUPERVISOR].name;
const ACCOUNTANT = RoleInfo[Role.ACCOUNTANT].name;
const CASHIER = RoleInfo[Role.CASHIER].name;
const LABOR = RoleInfo[Role.LABOR].name;

const ROLES = [ADMIN, MANAGER, ACCOUNTANT, SUPERVISOR, CASHIER, LABOR] as const;

export const STANDARD_ROLES = ROLES;

export const ROLE_HIERARCHY: Record<string, number> = {
  [ADMIN]: 100,
  [MANAGER]: 80,
  [ACCOUNTANT]: 70,
  [SUPERVISOR]: 60,
  [CASHIER]: 50,
  [LABOR]: 30,
};

export const MANAGEABLE_ROLES: Record<string, readonly string[]> = {
  [ADMIN]: [ADMIN, MANAGER, ACCOUNTANT, SUPERVISOR, CASHIER, LABOR],
  [MANAGER]: [CASHIER, SUPERVISOR, LABOR, ACCOUNTANT],
  [SUPERVISOR]: [CASHIER, LABOR],
  [ACCOUNTANT]: [],
  [CASHIER]: [],
  [LABOR]: [],
};

export const getRoleHierarchyLevel = (role: string): number =>
  ROLE_HIERARCHY[role] ?? 0;

export const canManageRole = (
  currentRole: string,
  targetRole: string,
): boolean => {
  const manageable = MANAGEABLE_ROLES[currentRole];
  if (!manageable) return false;
  return manageable.includes(targetRole);
};

export const hasHigherOrEqualHierarchy = (
  currentRole: string,
  targetRole: string,
): boolean => {
  return (
    getRoleHierarchyLevel(currentRole) >= getRoleHierarchyLevel(targetRole)
  );
};
